<template>
  <div class="edit-files-draggable">
    <BasePreloader v-if="pendingEdit"/>
    <draggable v-model="list"
               :animation="300"
               @start="dragging = true"
               @end="endDragable"
               draggable="._draggable"
               handle=".handle"
               class="edit-files-draggable__list">

      <div v-for="(item, index) in value"
           :key="item.id"
           class="edit-files-draggable__item _draggable">
        <div class="edit-files-draggable__item-inner">
          <button type="button"
                  @click="onDelete(index)"
                  class="edit-files-draggable__btn-delete">
            <BaseSvg name="ico-trash"/>
          </button>
          <FileShow :value="item"
                    class="edit-files-draggable__item-file  _cover  handle"/>
          <!--          <video v-if="isVideo(item)"-->
          <!--                 controls-->
          <!--                 autoplay-->
          <!--                 class="help-tooltip__video">-->
          <!--            <source type="video/webm"-->
          <!--                    :src="videoSrc.webm">-->
          <!--            <source type="video/mp4"-->
          <!--                    :src="item.link">-->
          <!--          </video>-->
          <!--          <img :src="item.link"-->
          <!--               alt="add"-->
          <!--               class="handle"/>-->
        </div>
        <div v-if="withCaption"
             class="edit-files-draggable__item-caption"
             :class="{'_default': !item.title}"
        >
          <template v-if="item.title">{{ getFileCaption(item) }}</template>
          <template v-else>
            {{ $tNewVacancy2('Without a signature') }}
          </template>
          <button type="button"
                  class="edit-files-draggable__item-caption-edit"
                  @click.prevent="onEditCaption(index)"
          >
            <BaseSvg name="ico-pencil"/>
          </button>

          <transition name="fade">
            <textarea v-if="item.captionEdit"
                      :rows="editCaptionRowsCount"
                      ref="editInput"
                      class="edit-files-draggable__item-caption-input"
                      v-model="item.title"
                      @keypress.enter.prevent="onEditCaptionBlur(index)"
                      @blur="onEditCaptionBlur(index)"></textarea>
          </transition>
        </div>
      </div>

      <div v-if="value.length < max"
           slot="footer"
           class="edit-files-draggable__item _add"
      >
        <div class="edit-files-draggable__item-inner edit-files-draggable__add"
             :class="{'_drag-over': dragoverMixin}"
             @drop.prevent="onDropMixin($event)"
             @dragover.prevent="onDragenterMixin"
             @dragleave.prevent="onDragleaveMixin"
        >
          <input
                  ref="fileInput"
                  class="d-none"
                  type="file"
                  :multiple="max > 1"
                  :accept="generateFilesTypes"
                  @change="onFilesInputMixin"
          >
          <button
                  class="edit-files-draggable__add-btn base-btn base-btn--blue"
                  @click="$refs.fileInput.click()"
          >
            <BasePreloader v-if="pending"/>
            <BaseSvg name="ico-plus"/>
            <span class="base-btn__text">{{$tNewVacancy2('Add')}}</span>
          </button>
        </div>
      </div>
    </draggable>
    <BaseAlertInline :value="errorMixin"
                     class="edit-files-draggable__errors  _error"/>
  </div>
</template>

<script>
  import fileUploadMixin from '../../mixins/fileUploadMixin'
  import BaseAlertInline from '../BaseAlertInline'
  import FileShow from '../FileShow'
  import draggable from 'vuedraggable'
  import {ALLOWED_IMAGES_EXTS, VIDEOS_TYPES} from '../../constants/files'

  export default {
    name: 'EditFilesDraggable',
    components: {
      BaseAlertInline,
      draggable,
      FileShow
    },
    mixins: [fileUploadMixin],
    props: {
      value: Array,
      error: [Object, Array, String],
      pending: {
        type: Boolean,
        default: false
      },
      pendingEdit: {
        type: Boolean,
        default: false,
      },
      max: {
        type: Number,
        default: 30
      },
      withCaption: {
        type: Boolean,
        default: true
      },
      maxCaptionLength: {
        type: Number,
        default: Infinity,
      },
      editCaptionRowsCount: {
        type: [Number, String],
        default: 2,
      },
      acceptFileType: {
        type: String
      }
    },
    data(v) {
      return {
        uploadFileMethodNameMixin: ['upload'],
        dragging: false,
        list: v.value,
      }
    },
    computed: {
      generateFilesTypes() {
        if(this.acceptFileType) return this.acceptFileType

        const concatTypesArray = ALLOWED_IMAGES_EXTS.concat(VIDEOS_TYPES)
        const typesString = concatTypesArray.join(', .')

        return '.' + typesString
      },
    },
    methods: {
      upload(files) {
        this.$emit('input', files)
      },
      onDelete(index) {
        this.$emit('delete', index)
      },
      onEditCaption(index) {
        this.$set(this.value[index], 'captionEdit', true)

        if (this.value[index].title) {
          this.$set(this.value[index], 'title', this.value[index].title.trim())
        }

        this.$nextTick(() => {
          this.$refs.editInput[0].focus()
        })
      },
      onEditCaptionBlur(index) {
        this.$set(this.value[index], 'captionEdit', false)

        if (this.value[index].title) {
          this.$set(this.value[index], 'title', this.value[index].title.trim())
        }
        this.$emit('update', this.value)
      },
      endDragable() {
        this.dragging = false
        this.$emit('update', this.list)
      },
      isVideo(file) {
        return VIDEOS_TYPES.includes(file.ext)
      },
      getFileCaption({ title }) {
        if (!this.maxCaptionLength) return title;
        return title.length > this.maxCaptionLength ? title.slice(0, this.maxCaptionLength - 3) + '...' : title;
      },
    },
    watch: {
      error(value) {
        if (value) {
          this.errorMixin = value
        }
      },
      value() {
        this.list = this.value
      }
    }
  }
</script>

<style>
</style>
